export function formatMoney(value) {
    if (value === null || value === undefined || value === "") {
      return "Não informado";
    }
    const numericValue = parseInt(String(value).replace(/\D/g, ""), 10);
    if (isNaN(numericValue)) {
      return "Não informado";
    }
    const valueInReais = numericValue / 100;
    return valueInReais.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  export function formatCentsToBRL(centsString){
  if (centsString === null || centsString === undefined || centsString === "")
    return "R$ 0,00";
  const numericValue = parseInt(String(centsString).replace(/\D/g, ""), 10);
  if (isNaN(numericValue)) return "R$ 0,00";
  const valueInReais = numericValue / 100;
  return valueInReais.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};
